// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader___-2G1V6FR9XO0tfWD4ZaIZtj","loader__inner":"loader__inner___-vWB5IH3dWptvD0OOcEQVV","loader__lds_grid":"loader__lds_grid___-3A5DZ7jHFzD_GkiN9GWYLG"};